export const fmtEUR = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(Number(n || 0));

export const fmtEURPrecise = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(Number(n || 0));

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString("fr-FR"); } catch { return iso; }
};

export const monthsFR = ["", "Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];

export const statusLabel = {
  paye: "Payé", partiel: "Partiel", retard: "En retard", impaye: "Impayé", a_venir: "À venir",
  occupe: "Occupé", vacant: "Vacant", travaux: "En travaux",
  appartement: "Appartement", maison: "Maison", studio: "Studio", local_commercial: "Local commercial",
  nu: "Nu", meuble: "Meublé", commercial: "Commercial",
  actif: "Actif", termine: "Terminé", resilie: "Résilié",
};
